/**
 * 모바일 관리자 — 기사 상세 시트(기사관리 Member)를 **다른 화면에서 여는 통로**.
 *
 * 시트 본체는 기사관리(Member)가 정본이다. 불러톡처럼 기사목록이 없는 화면은
 * Member 인스턴스를 목록 없이 하나 만들어 상세만 빌려 쓴다 — 시트는 자기 번호로
 * `/ma/ajax/member/{n}` 을 직접 조회하므로 목록(rows·$list)이 없어도 그려진다.
 *
 * 목록이 없으니 갱신(reload)은 시트를 닫는 것으로 대신하고, 대리진입 복귀지(from)는
 * 부른 화면을 그대로 준다 — 기본값(기사목록)으로 두면 톡에서 들어간 CS 가 엉뚱한
 * 화면에 떨어진다.
 */
import Member from './Member';

let inst = null;

/**
 * @param {number}   num       회원번호 (불러톡 방번호 = 회원번호)
 * @param {object}   [opts]
 * @param {string}   [opts.back]    대리진입 후 돌아올 곳. 기본은 지금 주소
 * @param {Function} [opts.onClose] 시트가 닫힐 때 1회
 */
export function openDriverSheet(num, opts = {}) {
    const n = parseInt(num, 10) || 0;
    if (!n) return;

    if (!inst) {
        inst = new Member();
        inst.reload = () => $j.Ui.BS.close();   // 되돌릴 목록이 없는 화면 — 시트만 닫는다
    }
    inst.backUrl = opts.back || (location.pathname + location.search);
    inst.openMember(n, opts.onClose);
}
